<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-image: url(); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-12 col-md-10">
                        <h1 class="display-2 text-white">Hola {{usuario.firstName}}</h1>
                        <p class="text-white mt-0 mb-5">Este es tu perfil. Aquí puedes gestionar tus datos personales.</p>
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#" @click="modals.modal0 = true">
                                        <img :src="usuario.user_img" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">{{count_dietas}}</span>
                                            <span class="description">Dietas</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{count_rutinas}}</span>
                                            <span class="description">Rutinas</span>
                                        </div>
                                        <div>
                                            <span class="heading">{{count_ejercicios}}</span>
                                            <span class="description">Ejercicios</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                    {{usuario.firstName}} {{usuario.lastName }}<span class="font-weight-light"></span>
                                </h3>
                                <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>{{usuario.city}}, {{usuario.country}}
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <base-alert class="alert-fixed" type="primary" v-if="notifications.success">
                        <strong>Datos actualizados con éxito!</strong>
                    </base-alert>
                    <base-alert class="alert-fixed" type="danger" v-if="notifications.failure">
                        <strong>Error, no se ha podido actualizar!</strong>
                    </base-alert>
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Mi cuenta</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <router-link to="/settings" class="btn btn-sm btn-primary">
                                        <span>Ajustes</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent="onFormSubmit">
                                <h6 class="heading-small text-muted mb-4">Información de usuario</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nombre de usuario"
                                                        placeholder="Nombre de usuario"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.user_name"
                                            />
                                            <small v-if="name_error" style="color:red;">Nombre de usuario ya en uso o con caracteres no permitidos.</small>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        type="email"
                                                        label="Correo electrónico"
                                                        placeholder="Correo electrónico"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.user_email"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nombre"
                                                        placeholder="Nombre"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.firstName"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Apellidos"
                                                        placeholder="Apellidos"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.lastName"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Información de contacto</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input alternative=""
                                                        label="Dirección"
                                                        placeholder="Dirección, Número"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.address"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Población"
                                                        placeholder="Población"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.city"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="País"
                                                        placeholder="País"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.country"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Código postal"
                                                        placeholder="Código postal"
                                                        input-classes="form-control-alternative"
                                                        v-model="usuario.zipCode"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-primary btn-block">Guardar</button>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
        <modal :show.sync="modals.modal0">
     <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Cambiar avatar</h5>
     </template>
     <div>
      
      <form @submit.prevent="onFormSubmit">
          <input
            type="file"
            name="user_img"
            id="user_img"
            @change="previewImage" accept="image/*"/>
        <small v-if="image_error" style="color:red;">Introduzca una imagen válida.</small>              
        <img
            v-if="usuario.user_img != null"
            :src="usuario.user_img"
             class="preview"
            alt=""
            id="ejercicio_pic"/>
        </form>
     </div>
     <template slot="footer">
         <span>Antes de subir una imagen asegúrese de completar el resto de campos del perfil.</span>
         <base-button type="secondary" @click="modals.modal0 = false">Cancelar</base-button>
         <base-button id="save" type="primary" @click="updateAvatar">Guardar cambios</base-button>
     </template>
   </modal>
    </div>
</template>
<script>
import { auth } from '../firebaseDb';
import { db } from '../firebaseDb';
import  { stor }  from '../firebaseDb';
  export default {
    name: 'user-profile',
    data() {
      return {
        user: auth.currentUser,
        usuario: {
          user_name: {
              type: String,
              default: 'username'
          },
          user_email: auth.currentUser.email,
          firstName: {
              type: String,
              default: 'Nombre'
          },
          lastName: {
              type: String,
              default: 'Apellidos'
          },
          address: {
              type: String,
              default: 'Dirección'
          },
          city: {
              type: String,
              default: 'Mi pueblo'
          },
          zipCode: {
              type: String,
              default: 'Código postal'
          },
          country: {
              type: String,
              default: 'País'
          },
          user_img:{
              type: String,
              default: "img/theme/team-4-800x800.jpg"
          }
        },
        count_dietas: 0,
        count_ejercicios: 0,
        count_rutinas: 0,
        modals: {
          modal0: false
        },
        notifications: {
            success: false,
            failure: false
        },
        name_error: false,
        image_error: false,

      }
    },
    created: function() {
      //console.log(this.user)
      var self = this
      db.collection('users').doc(this.user.uid).get()
      .then(function(doc){
        if(doc.exists){          
          try{
            let user_name = doc.data().user_name
            self.usuario.user_name = user_name
            
            let firstName = doc.data().firstName
            self.usuario.firstName = firstName

            let lastName = doc.data().lastName
            self.usuario.lastName = lastName

            let user_email = doc.data().user_email
            self.usuario.user_email = user_email

            let address = doc.data().address
            self.usuario.address = address

            let city = doc.data().city
            self.usuario.city = city

            let zipCode = doc.data().zipCode
            self.usuario.zipCode = zipCode

            let country = doc.data().country
            self.usuario.country = country

            let user_avatar = doc.data().user_avatar
            if (user_avatar != "") {
                self.usuario.user_img = user_avatar
            }            
          }catch(error){
            console.log(error)
          }
        }
      });
        db.collection('users').doc(this.user.uid).collection('dietas').get()
            .then(snapshot => this.count_dietas = snapshot.size);
        db.collection('users').doc(this.user.uid).collection('rutinas').get()
            .then(snapshot => this.count_rutinas = snapshot.size);
        db.collection('ejercicios').get()
            .then(snapshot => this.count_ejercicios = snapshot.size);
    
    },
    methods: {
        isValidUserName(){
            return this.usuario.user_name.match('^([a-z0-9_.]){4,30}$');
        },
        async isUserNameAvailable(){
            if (this.isValidUserName()) {
                const devolver = await db.collection('users').where('user_name', '==', this.usuario.user_name).where('user_email', '!=', this.usuario.user_email).get();
                return devolver.docs.length === 0;
            }
            return false;
        },
        async onFormSubmit(event) {
            event.preventDefault();
            let self = this;
            const isUserNameAvailable = await this.isUserNameAvailable()
            if (isUserNameAvailable === true) {
                this.track_profile();
                db.collection('users').doc(this.user.uid)
                .update({
                    user_name: this.usuario.user_name,
                    firstName: this.usuario.firstName,
                    lastName: this.usuario.lastName,
                    user_email: this.usuario.user_email,
                    address: this.usuario.address,
                    city: this.usuario.city,
                    zipCode: this.usuario.zipCode,
                    country: this.usuario.country,
                    user_avatar: this.usuario.user_img

                }).then(() => {
                    this.name_error = false;
                    this.notifications.success = true;
                    setTimeout(function() {
                        self.notifications.success = false;
                    }, 3000);                        
                }).catch((error) => {
                    console.log(error);
                    this.notifications.failure = true; 
                    setTimeout(function() {
                        self.notifications.failure = false;
                    }, 3000);                    
                });
            } else {
                this.name_error = true;
            }
            
        },        
        previewImage(event){
              this.uploadValue=0;
              this.usuario.user_img = event.target.files[0];
              console.log( this.usuario.user_img)
              this.onUpload();
        },
        onUpload(){
            let img_name = this.user.uid+this.usuario.user_img.name.substring(this.usuario.user_img.name.length-4, this.usuario.user_img.name.length)
            const storageRef=stor.ref('avatars/').child(img_name).put(this.usuario.user_img);
            storageRef.on(`state_changed`,snapshot=>{
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error=>{console.log(error.message)},
                ()=>{this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                    this.usuario.user_img =url;
                    //console.log(this.img1)
                    });
                }      
            );
        },
        updateAvatar(){
            let self = this;
            if (this.usuario.user_img != null || this.usuario.user_img != "" || this.usuario.user_img != "img/theme/team-4-800x800.jpg") {
                this.image_error = false;
                this.track_avatar();
                db.collection('users').doc(this.user.uid)
                .update({
                    user_avatar: this.usuario.user_img

                }).then(() => {
                    this.notifications.success = true;
                    this.modals.modal0 = false;
                    setTimeout(function() {
                        self.notifications.success = false;
                    }, 3000);  
                    //this.$router.go(0);                      
                }).catch((error) => {
                    console.log(error);
                    this.notifications.failure = true; 
                    setTimeout(function() {
                        self.notifications.failure = false;
                    }, 3000);                    
                });
                
            } else {
                this.image_error = true;
            }
        },
        track_profile() {
            this.$gtag.event("updated_profile", {
            'event_category': "profile",
            'event_label': "profile_updated",
            'value': 1
            })
        },
        track_avatar() {
            this.$gtag.event("updated_avatar", {
            'event_category': "profile",
            'event_label': "avatar_updated",
            'value': 1
            })
        },
            
    }
  };
</script>
<style>
img {
    max-width: 100%;
}
.alert-fixed {
    position:fixed; 
    top: 0px; 
    left: 0px; 
    width: 100%;
    z-index:9999; 
    border-radius:0px
}
</style>
